import { isTrustedHostname } from './trustedDomains';
export function isHttpUrl(url) {
  return url.protocol === 'http:' || url.protocol === 'https:';
}
export function isSameOrigin(url, forumUrl) {
  return url.origin === forumUrl.origin;
}
export function shouldProtectUrl(url, forumUrl, rules) {
  return isHttpUrl(url) && !isSameOrigin(url, forumUrl) && !isTrustedHostname(url.hostname, rules);
}
export function buildLinkGuardUrl(baseRoute, target) {
  return `${baseRoute}#${new URLSearchParams({
    url: target.href
  })}`;
}
export function parseLinkGuardTarget(hash) {
  const target = new URLSearchParams(hash.replace(/^#/, '')).get('url');
  if (!target) return null;
  try {
    const url = new URL(target);
    return isHttpUrl(url) ? url : null;
  } catch {
    return null;
  }
}
flarum.reg.add('ffans-link-guard', 'forum/utils/linkGuardUrl', { isHttpUrl: isHttpUrl,isSameOrigin: isSameOrigin,shouldProtectUrl: shouldProtectUrl,buildLinkGuardUrl: buildLinkGuardUrl,parseLinkGuardTarget: parseLinkGuardTarget, });